import { toast } from "@kyan/ui";
import { useEffect } from "react";

import { BRIDGE_STATUS_CONFIG } from "#/app/(desktop)/layouts/Header/components/Deposit/components/EquityModal/components/EquityModalContent/components/DepositForm/components/BridgeId/components/BridgeStatus/BridgeStatus.constants";
import { useUsdcBalance } from "#/hooks/useUsdcBalance";
import { RequestStatusEnum } from "#/services/bridge/bridge.types";
import { useBridgeStatus } from "#/services/bridge/hooks/useBridgeStatus";
import { useTokensList } from "#/services/bridge/hooks/useTokensList";

import { useBridgeState } from "./bridgeState";
import { useEquityModalTab } from "./equityModalTab";
import { useShowEquityModal } from "./showEquityModal";

export const BridgeStatusUpdater = () => {
  const { pendingTransactions } = useBridgeState();

  return (
    <>
      {pendingTransactions.map(({ requestHash }) => (
        <BridgeStatusUpdaterItem key={requestHash} requestHash={requestHash} />
      ))}
    </>
  );
};

interface BridgeStatusUpdaterItemProps {
  requestHash: string;
}

const BridgeStatusUpdaterItem: React.FC<BridgeStatusUpdaterItemProps> = ({
  requestHash,
}) => {
  const { data: bridgeStatus } = useBridgeStatus(requestHash);
  const { updateBridgeTxStatus } = useBridgeState();
  const { setShowEquityModal } = useShowEquityModal();
  const { setEquityModalTab } = useEquityModalTab();
  const { refetch: refetchTokens } = useTokensList();
  const { refetch: refetchUSDCBalance } = useUsdcBalance();

  useEffect(() => {
    const status = bridgeStatus?.bungeeStatusCode ?? RequestStatusEnum.PENDING;

    // Bridge is settled
    if (status >= RequestStatusEnum.FULFILLED) {
      if (
        [RequestStatusEnum.FULFILLED, RequestStatusEnum.SETTLED].includes(
          status,
        )
      ) {
        toast.success({
          title: "Bridge successful",
          description: "Funds bridged successfully.",
          action: {
            label: "Deposit",
            onClick: () => {
              setEquityModalTab("deposit");
              setShowEquityModal(true);
            },
          },
        });

        refetchTokens();
        refetchUSDCBalance();
      } else {
        const { label, description } = BRIDGE_STATUS_CONFIG[status];
        toast.error({
          title: `Bridge ${label.toLowerCase()}`,
          description,
        });
      }
      updateBridgeTxStatus(requestHash, status);
    }
  }, [
    requestHash,
    bridgeStatus,
    updateBridgeTxStatus,
    refetchTokens,
    refetchUSDCBalance,
  ]);

  return null;
};
